import { render, staticRenderFns } from "./PatientProfileEditDialog.vue?vue&type=template&id=02c99bca&scoped=true&"
import script from "./PatientProfileEditDialog.vue?vue&type=script&lang=ts&"
export * from "./PatientProfileEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PatientProfileEditDialog.vue?vue&type=style&index=0&id=02c99bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c99bca",
  null
  
)

export default component.exports